import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { Session } from '../types/session.types';
import { MuniEnvironmentParams } from '../types/muni-environment';

@Injectable()
export class SessionService {
  constructor(
    private readonly http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) private config: EnvironmentConfig
  ) { }

  public getSession(): Observable<Session.SessionModel> {
    const { apiHost } = this.config.params as MuniEnvironmentParams;

    return this.http.get<Session.SessionModel>(`${apiHost}/api/v1/session`);
  }

  public reLoadSession(): Observable<HttpResponse<Session.SessionModel>> {
    const { apiHost } = this.config.params as MuniEnvironmentParams;

    return this.http.post<Session.SessionModel>(`${apiHost}/api/v1/session/refresh`, {}, { observe: 'response' });
  }
}
